import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, RouterOutlet } from '@angular/router';
import { remove } from 'lodash';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { AppEvent } from 'src/app/data/models/app-event';
import { ChatMessageToSendDto } from 'src/app/data/models/dto/chat-message-to-send.dto';
import { ConfirmRoomMessageRemovedDto } from 'src/app/data/models/dto/confirm-room-message-removed.dto';
import { ConfirmRoomMessageVisualizedDto } from 'src/app/data/models/dto/confirm-room-message-visualized.dto';
import { ConfirmUserMessageReceivedDto } from 'src/app/data/models/dto/confirm-user-message-received.dto';
import { ConfirmUserMessageRemovedDto } from 'src/app/data/models/dto/confirm-user-message-removed.dto';
import { ConfirmUserMessageVisualizedDto } from 'src/app/data/models/dto/confirm-user-message-visualized.dto';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { AppEventType } from 'src/app/data/models/enum/app-event-type.enum';
import { ChatTypeEnum } from 'src/app/data/models/enum/chat-type.enum';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { ChatMessageToSendService } from 'src/app/data/services/chat-message-to-send.service';
import { EventQueueService } from 'src/app/data/services/event-queue.service';
import { RoomsService } from 'src/app/data/services/rooms.service';
import { blockedAttachmentsMessage } from 'src/app/data/utils/attachment-security.utils';
import { FileUtils } from 'src/app/data/utils/file.utils';
import { AttachmentManagerComponent } from 'src/app/ui/components/attachment-manager/attachment-manager.component';
import { CustomSnackbarService } from 'src/app/ui/components/custom-snackbar/custom-snackbar-service';
import { createRoomMessage } from '../../../../data/factory/room-message-factory';
import { createUserMessage } from '../../../../data/factory/user-message-factory';
import {
  ChatItemDetailsDto,
  createItemDetails,
} from '../../../../data/models/dto/chat-item-details.dto';
import { FileContentDto } from '../../../../data/models/dto/file-content.dto';
import { RoomMessageDto } from '../../../../data/models/dto/room-message.dto';
import { UserHeaderDto } from '../../../../data/models/dto/user-header.dto';
import { RoomMessage } from '../../../../data/models/interfaces/room-message.interface';
import { UserMessage } from '../../../../data/models/interfaces/user-message.interface';
import { ChatsGatewayService } from '../../../../data/services/chats-gateway.service';
import { FileService } from '../../../../data/services/file.service';
import { RoomsMessagesService } from '../../../../data/services/rooms-messages.service';
import { UsersMessagesService } from '../../../../data/services/users-messages.service';
import { UserUtil } from '../../../../data/utils/user.utils';
import { RoomMessageParamsDto } from './../../../../data/models/dto/room-message-params.dto';
import { UserMessageParamsDto } from './../../../../data/models/dto/user-message-params.dto';
import { PushNotificationService } from './../../../../data/services/push-notification.service';
import { TicketsService } from 'src/app/modules/tickets/services/tickets.service';
import { Ticket } from 'src/app/modules/tickets/models';
import { TicketParamsDto, UpdateTicketDto, UpdateTicketEventDto } from 'src/app/modules/tickets/dtos';
import { TicketStatus } from 'src/app/modules/tickets/enum/ticket-status.enum';
import { TicketsGatewayService } from 'src/app/modules/tickets/services/tickets-gateway.service';
import { TicketsSharedService } from 'src/app/modules/tickets/services/tickets-shared.service';
import { ChatMessageDto } from 'src/app/data/models/dto/chat-message.dto';
import { ContractedFeatureUtil } from 'src/app/data/utils/contracted-feature.utils';
import { NetworkService } from 'src/app/data/services/network.service';
import { MessageSendStatus } from './../../../../data/models/enum/message-send-status.enum';

@Component({
  selector: 'app-chats-details',
  templateUrl: './chats-details.component.html',
  styleUrls: ['./chats-details.component.scss'],
})
export class ChatsDetailsComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() itemDetails?: ChatItemDetailsDto;
  @Input() userDetailsVisible: boolean = false;
  @Input() chatMessages: ChatMessageDto[] = [];
  @Output() showArchivedChange = new EventEmitter<boolean>();

  roomMembersLength?: number;
  idRoom: string | undefined;
  idUserFromRoom: string | undefined;
  idDestUser: string | undefined;
  destUserName: string = '';
  userHeaderDto: UserHeaderDto | undefined;

  placeholder: string = 'Digite a mensagem';
  attachIconVisible: boolean = true;
  sendMessageText: string = '';
  sendButtonDisable: boolean = true;
  loading: boolean = false;

  dataFile: string[] | null = [];
  showFile: boolean = false;
  userId: string = '';
  userName: string = '';

  messages: any[] = [];
  chatType!: ChatTypeEnum;
  chatId = '';

  pendingRoomMessages: RoomMessage[] = [];
  pendingUserMessages: UserMessage[] = [];

  ticket: Ticket | null = null;

  private subscription!: Subscription;

  filesContentDto: FileContentDto[] = [];

  infiniteScrollDisabled = false;
  stopFetchData = false;

  @ViewChild('scrollContainer')
  scrollContainer!: ElementRef;
  scrollContainerNative: any;

  scrollTopPosition: number | undefined;

  //pagination
  roomMessagesParams: RoomMessageParamsDto = { page: 1, limit: 50 };
  userMessagesParams: UserMessageParamsDto = { page: 1, limit: 50 };
  totalPages: number | undefined;

  //foward
  enableForward: boolean = false;
  forwardList: RoomMessage[] = [];
  idChannel: string | undefined;

  hasChatsGatewayInitialized = false;

  constructor(
    private chatMessageToSendService: ChatMessageToSendService,
    private readonly userUtil: UserUtil,
    private readonly route: ActivatedRoute,
    private readonly gatewayService: ChatsGatewayService,
    private readonly ticketGatewayService: TicketsGatewayService,
    private readonly networkService: NetworkService,
    private readonly roomsService: RoomsService,
    private readonly roomsMessagesService: RoomsMessagesService,
    private readonly userMessageService: UsersMessagesService,
    private readonly fileService: FileService,
    private readonly fileUtils: FileUtils,
    private readonly notificationService: PushNotificationService,
    private readonly routerOutlet: RouterOutlet,
    private readonly ticketService: TicketsService,
    private readonly ticketSharedService: TicketsSharedService,
    private eventQueue: EventQueueService,
    public dialog: MatDialog,
    private snackbarService: CustomSnackbarService,
    private contractedFeatureUtil: ContractedFeatureUtil,
  ) {
    this.subscription = new Subscription();
  }

  ngAfterViewInit(): void {
    this.scrollContainerNative = this.scrollContainer.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itemDetails']) {
      this.cancelForward();
      this.init();
    }
  }

  ngOnDestroy() {
    this.unsubscribeObservers();
    this.notificationService.enableChatNotifications();
  }

  private unsubscribeObservers() {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.notificationService.disableChatNotifications();

    this.registerSubscriptions();

    this.networkService.isOnline$.subscribe(isOnline => {
      if (isOnline && this.pendingRoomMessages.length > 0) {
        this.pendingRoomMessages.forEach(temp => {
          const roomMessage: RoomMessage = {
            ...temp,
          };

          this.sendRoomMessageOnServer(roomMessage, [], temp);
        });
        this.pendingRoomMessages = [];
      }
      if (isOnline && this.pendingUserMessages.length > 0) {
        this.pendingUserMessages.forEach(temp => {
          const userMessage: UserMessage = {
            ...temp,
          };

          this.sendUserMessageOnServer(userMessage, temp);
        });
        this.pendingUserMessages = [];
      }
    });


    if (this.routerOutlet.activatedRouteData.userHeaderDto) {
      this.init();
    }
  }

  private registerSubscriptions() {
    let subRouteParams = this.route.params.subscribe((params: Params) => {
      let json = params['details'];
      if (json) {
        let data = JSON.parse(params['details']);
        this.routerOutlet.activatedRouteData.title = '';
        this.routerOutlet.activatedRouteData.userHeaderDto = data.headerDto;
        if (data.idRoom)
          this.itemDetails = createItemDetails(
            true,
            data.idRoom,
            undefined,
            undefined,
            data.headerDto,
            data.getRoomFromChatMessages
          );
        else
          this.itemDetails = createItemDetails(
            false,
            undefined,
            data.idDestUser,
            data.navTitle,
            data.headerDto,
            undefined
          );
      }
    });

    this.subscription.add(subRouteParams);

    const subReconnect = combineLatest([
      this.networkService.isOnline$,
      this.gatewayService.socketStatus$,
    ]).subscribe(([isOnline, isChatsGatewayConnected]) => {
      if (isOnline && !isChatsGatewayConnected && this.hasChatsGatewayInitialized) {
        if (this.itemDetails?.isRoomMessage) {
          this.roomMessagesParams.page = 1;
          this.initRoomMessage();
        }
        else {
          this.userMessagesParams.page = 1;
          this.initUserMessage();
        }
      }
    });
    this.subscription.add(subReconnect);
  }

  private initMessageToSend() {
    if (this.itemDetails) {
      this.chatType = this.itemDetails!.isRoomMessage
        ? ChatTypeEnum.ROOM_MESSAGE
        : ChatTypeEnum.USER_MESSAGE;
      this.chatId = this.itemDetails!.isRoomMessage
        ? this.idRoom!
        : this.idDestUser!;
      this.sendMessageText = this.chatMessageToSendService.getMessage(
        this.chatType,
        this.chatId
      );
      this.sendMessageText.trim().length > 0
        ? this.enableSendButton()
        : this.disableSendButton();
    }
  }

  private clearData() {
    this.idRoom = undefined;
    this.idUserFromRoom = undefined;
    this.messages = [];
    this.infiniteScrollDisabled = false;
    this.stopFetchData = false;
    this.roomMessagesParams = { page: 1, limit: 50 };
    this.userMessagesParams = { page: 1, limit: 50 };
  }

  private init() {
    this.clearData();

    const user = this.userUtil.getUser();
    this.userId = user.id;
    this.userName = user.firstName + ' ' + user.lastName;

    this.connected();
    this.disconnected();
    this.ticketConnected();
    this.ticketDisconnected();

    if (this.itemDetails) {
      if (this.itemDetails.isRoomMessage) this.initRoomMessage();
      else this.initUserMessage();
    }

    this.filesContentDto = [];
    this.initMessageToSend();
    this.hasChatsGatewayInitialized = true;
  }

  async initTicket() {
    const params: TicketParamsDto = {
      idRoom: this.idRoom,
      active: true
    };

    const ticketArray = await this.ticketService.findAll(params).toPromise();
    this.ticket = (ticketArray.length === 0 ? null : ticketArray[0])
    this.ticketSharedService.triggerEventFromChatDetails(this.ticket);
  }

  private initRoomMessage() {
    this.idRoom = this.itemDetails?.idRoom;
    this.userHeaderDto = this.itemDetails?.headerDto;
    this.roomMessagesParams.idRoom = this.idRoom;
    this.infiniteScrollDisabled = false;

    if (this.idRoom) {
      this.initTicket();
      this.roomCreated();
      this.joinTicketRoom();
      this.createRoom(this.idRoom);
      this.createTicketRoom();
      this.getRoomById(this.idRoom);
      this.getRoomsMessagesPaginated(this.roomMessagesParams);
      this.receiveRoomMessagesV2FromSocket();
      this.receiveRoomMessageVisualizedFromSocket();
      this.receiveRoomMessageRemovedFromSocket();
      this.receiveCreatedTicketFromSocket();
      this.receiveClosedTicketFromSocket();
      this.receiveReOpenedTicketFromSocket();
    }
  }

  private initUserMessage() {
    this.idDestUser = this.itemDetails?.idDestUser;
    this.destUserName = this.itemDetails?.destUserName ?? '';
    this.userHeaderDto = this.itemDetails?.headerDto;
    this.userMessagesParams.idAuthor = this.userId;
    this.userMessagesParams.idDest = this.idDestUser;
    this.infiniteScrollDisabled = false;

    if (this.idDestUser) {
      this.getUsersMessagesPaginated(this.userMessagesParams);
      this.receiveUserMessagesV2FromSocket();
      this.receiveUserMessageConfirmedFromSocket();
      this.receiveUserMessageVisualizedFromSocket();
      this.receiveUserMessageRemovedFromSocket();
    }
  }

  /* ------ GATEWAY METHODS -------- */
  connected() {
    let subs = this.gatewayService.connected().subscribe((id) => {
      console.log(`user: ${id} connected`);
    });

    this.gatewayService.joinPrivateRoom(this.userId);

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  ticketConnected() {
    let subs = this.ticketGatewayService.connected().subscribe((id) => {
      console.log(`user: ${id} connected to ticket connection`);
    });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  disconnected() {
    let subs = this.gatewayService.disconnected().subscribe((id) => {
      console.log(`user: ${id} disconnected`);
    });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  ticketDisconnected() {
    let subs = this.ticketGatewayService.disconnected().subscribe((id) => {
      console.log(`user: ${id} disconnected from ticket connection`);
    });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  roomCreated() {
    let subs = this.gatewayService.roomCreated().subscribe((roomName) => {
      if (this.idRoom === roomName) {
        console.log(`Room: ${roomName} created`);
      }
    });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  joinTicketRoom() {
    let subs = this.ticketGatewayService.ticketRoomCreated().subscribe((roomName) => {
      if (this.idRoom === roomName) {
        console.log(`Ticket Room: ${roomName} created`);
      }
    });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  createTicketRoom() {
    this.ticketGatewayService.createTicketRoom(this.idRoom!);
  }

  createRoom(idRoom: string) {
    this.gatewayService.createRoom(idRoom);
  }

  private receiveCreatedTicketFromSocket() {
    let subs = this.ticketGatewayService
      .receiveCreatedTicket()
      .subscribe(async (message) => {
        if (this.idRoom === message.idRoom) {
          this.ticket = await this.ticketService.findById(message.idTicket).toPromise();
          this.ticketSharedService.triggerEventFromChatDetails(this.ticket);
        }
      })

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveReOpenedTicketFromSocket() {
    let subs = this.ticketGatewayService
      .receiveReOpenedTicket()
      .subscribe(async (message) => {
        if (this.idRoom === message.idRoom) {
          this.ticket = await this.ticketService.findById(message.idTicket).toPromise();
          this.ticketSharedService.triggerEventFromChatDetails(this.ticket);
        }
      })

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveClosedTicketFromSocket() {
    let subs = this.ticketGatewayService
      .receiveClosedTicket()
      .subscribe(async (message) => {
        if (this.idRoom === message.idRoom) {
          this.ticket = null;
          this.ticketSharedService.triggerEventFromChatDetails(this.ticket);
        }
      })

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveRoomMessagesV2FromSocket() {
    let subs = this.gatewayService
      .receiveRoomMessageV2()
      .subscribe(async (message) => {
        if (this.idRoom === message.idRoom) {
          this.addRoomMessagesToList(message);

          // patch api
          await this.roomsMessagesService.confirmVisualized(message.id!);

          const confirmMessage = {
            id: message.id,
            idRoom: message.idRoom,
            idUser: this.userId,
          } as ConfirmRoomMessageVisualizedDto;

          // gateway
          await this.gatewayService.confirmRoomMessageVisualized(
            confirmMessage
          );
        }
      });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveRoomMessageVisualizedFromSocket() {
    let subs = this.gatewayService
      .receiveRoomMessageVisualized()
      .subscribe(async (message) => {
        // update visualized icon
        const item = this.messages.find(
          (m) => m.id === message.id
        ) as RoomMessage;
        if (item.membersWhoVisualized && !item.membersWhoVisualized.includes(message.idUser)) {
          item.membersWhoVisualized.push(message.idUser);
        }
      });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveUserMessagesV2FromSocket() {
    const idDest =
      this.itemDetails && this.itemDetails.idDestUser
        ? this.itemDetails.idDestUser
        : '';

    let subs = this.gatewayService
      .receiveUserMessageV2()
      .subscribe(async (message) => {
        if (
          (message.idAuthor == idDest && message.idDest == this.userId) ||
          (message.idAuthor == this.userId && message.idDest == idDest)
        ) {
          this.addUserMessagesToList(message);

          await this.userMessageService.confirmReceived(message.id!);
          await this.gatewayService.confirmUserMessageReceived(<
            ConfirmUserMessageReceivedDto
            >{
              id: message.id,
              idUser: message.idAuthor,
            });

          await this.userMessageService.confirmVisualized(message.id!);
          await this.gatewayService.confirmUserMessageVisualized(<
            ConfirmUserMessageVisualizedDto
            >{
              id: message.id,
              idUser: message.idAuthor,
            });
        }
      });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveUserMessageConfirmedFromSocket() {
    let subs = this.gatewayService
      .receiveUserMessageConfirmed()
      .subscribe((message): void => {
        // update received icon
        const item = this.messages.find(
          (m) => m.id === message.id
        ) as UserMessage;
        item.received = true;
      });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveUserMessageVisualizedFromSocket() {
    let subs = this.gatewayService
      .receiveUserMessageVisualized()
      .subscribe((message): void => {
        // update visualized icon
        const item = this.messages.find(
          (m) => m.id === message.id
        ) as UserMessage;
        item.visualized = true;
      });

    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private sendUserMessageV2ToSocket(message: UserMessage) {
    this.addUserMessagesToList(message);
    this.gatewayService.sendUserMessageV2(message);
  }

  private sendRoomMessageV2ToSocket(message: RoomMessageDto) {
    if (this.idRoom) {
      this.gatewayService.sendRoomMessageV2(message);
    }
  }

  private receiveUserMessageRemovedFromSocket() {
    let subs = this.gatewayService
      .receiveUserMessageRemoved()
      .subscribe(async (message) => {
        // update active status
        const item = this.messages.find(
          (m) => m.id == message.id
        ) as UserMessage;
        item.active = false;
      });
    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  private receiveRoomMessageRemovedFromSocket() {
    let subs = this.gatewayService
      .receiveRoomMessageRemoved()
      .subscribe(async (message) => {
        if (this.idRoom == message.idRoom) {
          // update active status
          const item = this.messages.find(
            (m) => m.id == message.id
          ) as RoomMessageDto;
          item.active = false;
        }
      });
    if (this.subscription) {
      this.subscription.add(subs);
    }
  }
  /* ------ GATEWAY METHODS -------- */

  getRoomById(id: string) {
    let subs = this.roomsService.getById(id).subscribe((res) => {
      this.roomMembersLength = res.members.length;
      this.idChannel = res.idChannel;
      this.idUserFromRoom = res.idUser;
      if (this.userHeaderDto) {
        this.userHeaderDto.id = res.idUser;
      }
    });
    if (this.subscription) {
      this.subscription.add(subs);
    }
  }

  async getRoomsMessagesPaginated(params: RoomMessageParamsDto) {
    if (!this.infiniteScrollDisabled) {
      this.loading = true;
    }

    try {
      const response = await this.roomsMessagesService
        .getAllV2(params)
        .toPromise();

      if (response.data.length > 0) {
        this.totalPages = response.totalPages;
        this.roomMessagesParams = params;

        const existingIds = new Set(this.messages.map(m => m.id));
        const filtered = response.data.filter(msg => !existingIds.has(msg.id));
        this.messages.push(...filtered);
        this.messages = this.sortMessages(this.messages);

        this.updateMembersVisualizedMessages(this.messages as RoomMessageDto[]);
      } else {
        this.stopFetchData = true;
      }
    } catch (error: any) {
     this.messages = [];
    } finally {
      this.loading = false;
    }
  }

  updateMembersVisualizedMessages(roomMessages: RoomMessageDto[]) {
    roomMessages.forEach((message: RoomMessageDto) => {
      this.updateUserVisualizedForMessage(message);
    });
  }

  async getUsersMessagesPaginated(params: UserMessageParamsDto) {
    if (!this.infiniteScrollDisabled) {
      this.loading = true;
    }

    try {
      const response = await this.userMessageService
        .findAllV2(params)
        .toPromise();

      if (response.data.length > 0) {
        this.totalPages = response.totalPages;
        this.userMessagesParams = params;

        const existingIds = new Set(this.messages.map(m => m.id));
        const filtered = response.data.filter(msg => !existingIds.has(msg.id));
        this.messages.push(...filtered);
        this.messages = this.sortMessages(this.messages);

        this.updateUsersMessagesStatus(this.messages as UserMessage[]);
      } else {
        this.stopFetchData = true;
      }
    } catch (error: any) {
      this.messages = [];
    } finally {
      this.loading = false;
    }
  }

  private updateUsersMessagesStatus(usersMessages: UserMessage[]) {
    usersMessages.forEach((message: UserMessage) => {
      this.updateMessagesStatus(message);
    });
  }

  private async updateMessagesStatus(message: UserMessage) {
    if (message.idDest === this.userId) {
      await this.updateMessagesReceived(message);
      await this.updateMessagesVisualized(message);
    }
  }

  private async updateMessagesReceived(message: UserMessage) {
    message.received = message.idDest === this.userId;

    if (message.id)
      this.userMessageService
        .confirmReceived(message.id)
        .toPromise()
        .then(() => {
          this.gatewayService.confirmUserMessageReceived(<
            ConfirmUserMessageReceivedDto
            >{
              id: message.id,
              idUser: message.idAuthor,
            });
        });
  }

  private async updateMessagesVisualized(message: UserMessage) {
    message.visualized = message.idDest === this.userId;

    if (message.id)
      this.userMessageService
        .confirmVisualized(message.id)
        .toPromise()
        .then(() => {
          this.gatewayService.confirmUserMessageVisualized(<
            ConfirmUserMessageVisualizedDto
            >{
              id: message.id,
              idUser: message.idAuthor,
            });
        });
  }

  private buildMessageToSend(messageToSend: string): ChatMessageToSendDto {
    return {
      type: this.itemDetails!.isRoomMessage
        ? ChatTypeEnum.ROOM_MESSAGE
        : ChatTypeEnum.USER_MESSAGE,
      id: this.itemDetails!.isRoomMessage ? this.idRoom! : this.idDestUser!,
      text: messageToSend,
    } as ChatMessageToSendDto;
  }

  sendMessageChange(event: any) {
    let value = (<HTMLInputElement>event.target).value.replace(/\n/g, '');
    if (value != '' && value.length > 0) this.enableSendButton();
    else {
      this.disableSendButton();
      (<HTMLInputElement>event.target).value = '';
    }
    const messageToSend = this.buildMessageToSend(value);
    this.chatMessageToSendService.pushMessage(messageToSend);
  }

  private enableSendButton() {
    this.sendButtonDisable = false;
  }

  private disableSendButton() {
    this.sendButtonDisable = true;
  }

  sendMessageClick() {
    if (this.sendMessageText.replace(/\n/g, '').length > 0) {
      if (!this.itemDetails?.isRoomMessage) {
        const userMessage = createUserMessage(
          this.userId,
          this.idDestUser ?? '',
          this.sendMessageText
        );
        this.handleSendUserMessage(userMessage);
      } else {
        if (this.idRoom) {
          const roomMessage = createRoomMessage(
            this.idRoom,
            this.userId,
            this.sendMessageText
          );
          this.handleSendRoomMessage(roomMessage);
        }
      }
      this.clearInputMessage();
    }
  }
  private createTempUserMessage(message: UserMessage): UserMessage {
    const tempId = 'temp-' + Date.now() + '-' + Math.random().toString(36).slice(2);

    return {
      ...message,
      tempId,
      dtMessage: new Date(),
      sendStatus: MessageSendStatus.PENDING,
    } as UserMessage;
  }

  private createTempRoomMessage(roomMessage: RoomMessage): RoomMessage{
  const tempId = 'temp-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  return {
    ...roomMessage,
    id: undefined,
    tempId,
    dtMessage: new Date(),
    sendStatus: MessageSendStatus.PENDING,
  } as RoomMessage;
}

  private handleSendRoomMessage(message: RoomMessage) {
    const tempMessage = this.createTempRoomMessage(message);

    this.addRoomMessagesToList(tempMessage);

    if(!this.networkService.isOnline$.value) {
      this.pendingRoomMessages.push(tempMessage);
      return;
    }

    this.sendRoomMessageOnServer(message, [], tempMessage);
  }

  private handleSendUserMessage(message: UserMessage) {
    const tempMessage = this.createTempUserMessage(message);

    this.addUserMessagesToList(tempMessage);

    if (!this.networkService.isOnline$.value) {
      this.pendingUserMessages.push(tempMessage);
      return;
    }

    this.sendUserMessageOnServer(message, tempMessage);
  }


  private findTempMessageIndex(tempId: string): number {
    return this.messages.findIndex(m => m.tempId === tempId);
  }

  private replaceTempWithServerMessage(temp: RoomMessage, serverMessage: RoomMessageDto) {
    const index = this.findTempMessageIndex(temp.tempId!);
    if (index === -1) return;

    this.messages[index] = {
      ...serverMessage,
      tempId: temp.tempId,
      sendStatus: MessageSendStatus.SUCCESS,
    };

    this.messages = this.sortMessages([...this.messages]);
  }

  private markTempRoomMessageAsError(temp: RoomMessage) {
    const index = this.findTempMessageIndex(temp.tempId!);
    if (index === -1) return;

    this.messages[index] = {
      ...this.messages[index],
      sendStatus: MessageSendStatus.ERROR,
    };

    this.messages = [...this.messages];
  }

  private markTempUserMessageAsError(temp: UserMessage) {
    const index = this.findTempMessageIndex(temp.tempId!);
    if (index === -1) return;

    this.messages[index] = {
      ...this.messages[index],
      sendStatus: MessageSendStatus.ERROR,
    };

    this.messages = [...this.messages];
  }

  retrySendRoomMessage(msg: RoomMessageDto) {
    msg.sendStatus = MessageSendStatus.PENDING;
    this.messages = [...this.messages];

    const roomMessage: RoomMessage = {
      ...msg,
    };

    this.sendRoomMessageOnServer(roomMessage, [], msg);
  }

  retrySendUserMessage(msg: UserMessage) {
    msg.sendStatus = MessageSendStatus.PENDING;
    this.messages = [...this.messages];

    const userMessage: UserMessage = {
      ...msg,
    };

    this.sendUserMessageOnServer(userMessage, msg);
  }


  private sendRoomMessageOnServer(message: RoomMessage, files: any[], temp: RoomMessage) {
    this.roomsMessagesService
      .create(message)
      .toPromise()
      .then((response): void => {
        this.eventQueue.dispatch(
          new AppEvent(AppEventType.SENDED_ROOM_CHAT_MESSAGE, response)
        );
        this.disableSendButton();
        this.addRoomMessagesToList(temp);
        this.replaceTempWithServerMessage(temp, response);

        this.sendRoomMessageV2ToSocket(response);
      })
      .catch(() => {
        console.error('Erro ao enviar mensagem');
        if (temp) {
          this.markTempRoomMessageAsError(temp);
        }
      });
  }

  private sendUserMessageOnServer(message: UserMessage, temp?: UserMessage) {
    this.userMessageService
      .create(message)
      .toPromise()
      .then((response) => {
        this.eventQueue.dispatch(
          new AppEvent(AppEventType.SENDED_USER_CHAT_MESSAGE, response)
        );
        this.disableSendButton();
        this.updateTempUserMessageFromServer(response, temp);

        this.sendUserMessageV2ToSocket(response);
      })
      .catch((err) => {
        console.error('Erro ao enviar mensagem', err);
        if (temp) {
          this.markTempUserMessageAsError(temp);
        }
      });
  }

  private updateTempUserMessageFromServer(
    serverMessage: UserMessage,
    temp?: UserMessage
  ) {
    const index = this.messages.findIndex(
      m => m.tempId && temp && m.tempId === temp.tempId
    );

    if (index !== -1) {
      this.messages[index] = {
        ...serverMessage,
        tempId: temp?.tempId,
        sendStatus: MessageSendStatus.SUCCESS,
      };

      this.messages = this.sortMessages(this.messages);
    }
  }

  private clearInputMessage(): void {
    this.chatMessageToSendService.removeMessage(this.chatType, this.chatId);
    this.sendMessageText = '';
    this.disableSendButton();
  }

  onFileChange(event: any) {
    let isdFiles: string[] = [];
    const files: File[] = [];
    for (var i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      files.push(file);
      isdFiles.push(file.name);
    }

    const { allowed, blocked } = this.fileUtils.splitAllowedAttachments(files);

    // Nenhum arquivo válido: avisa e não abre o gerenciador de anexos.
    if (allowed.length === 0) {
      const element = event.target as HTMLInputElement;
      element.value = '';

      if (blocked.length > 0) {
        this.snackbarService.open(
          blockedAttachmentsMessage(blocked),
          SnackbarTypeEnum.WARNING,
          'center',
          'top'
        );
      }
      return;
    }

    const dialogRef = this.dialog.open(AttachmentManagerComponent, {
      panelClass: 'custom-dialog',
      data: files,
    });
    dialogRef
      .afterClosed()
      .toPromise()
      .then((result: any) => {
        this.handleFiles(result);
        const element = event.target as HTMLInputElement;
        element.value = '';
      });
  }

  private handleFiles(files: File[]): void {
    if (files) {
      // Última barreira: garante que nenhum arquivo perigoso chegue ao upload.
      const { allowed } = this.fileUtils.splitAllowedAttachments(files);
      allowed.forEach((f: File) => {
        if (!this.itemDetails?.isRoomMessage) {
          const userMessage = createUserMessage(
            this.userId,
            this.idDestUser ?? '',
            'File',
            f
          );
          this.messages.unshift(userMessage);
        } else if (this.idRoom) {
          const roomMessage = createRoomMessage(
            this.idRoom,
            this.userId,
            'File',
            f
          );
          this.messages.unshift(roomMessage as RoomMessageDto);
        }
      });
    }
  }

  private updateUserVisualizedForMessage(message: RoomMessageDto) {
    if (
      message.membersWhoVisualized &&
      !message.membersWhoVisualized.includes(this.userId)
    ) {
      message.membersWhoVisualized.push(this.userId);
      if (message.id)
        this.roomsMessagesService.confirmVisualized(message.id).toPromise();
    }
  }

  private async addUserMessagesToList(message: UserMessage) {
    const msgWithStatus = {
      ...message,
      sendStatus: message.sendStatus ?? MessageSendStatus.SUCCESS,
    };

    this.messages.push(msgWithStatus);
    this.messages = this.removeDuplicate(this.messages);
    this.messages = this.sortMessages(this.messages);

    const lastMessage = this.messages[0] as UserMessage;
    this.updateUsersMessagesStatus([lastMessage]);
  }

  private addRoomMessagesToList(message: RoomMessage) {
    const msgWithStatus = {
      ...message,
      sendStatus: message.sendStatus ?? MessageSendStatus.SUCCESS,
    };

    this.messages.push(msgWithStatus);
    this.messages = this.removeDuplicate(this.messages);
    this.messages = this.sortMessages(this.messages);

    const lastMessage = this.messages[0] as RoomMessageDto;
    this.updateMembersVisualizedMessages([lastMessage]);
  }

  private removeDuplicate(list: any[]) {
    const unique = Array.from(
      new Set(list.map((a) => a.id ?? a.tempId))
    ).map((key) => {
      return list.find((a) => (a.id ?? a.tempId) === key);
    });

    return unique;
  }

  private sortMessages(messages: RoomMessageDto[]): RoomMessageDto[] {
    return [...messages].sort((a, b) => {
      const da = a.dtMessage ? new Date(a.dtMessage).getTime() : 0;
      const db = b.dtMessage ? new Date(b.dtMessage).getTime() : 0;
      return db - da;
    });
  }

  onKeydownEnter() {
    this.sendMessageClick();
  }

  onKeydownControlEnter() {
    if (this.sendMessageText.replace(/\n/g, '').length > 0)
      this.sendMessageText += '\n';
  }

  onCancelUpload(event: boolean, message: any) {
    if (event) {
      remove(this.messages, (msg) => msg === message);
    }
  }

  async onSuccessUpload(fileDto: FileDto, message: any) {
    try {
      if (fileDto) {
        message.files = [fileDto];
        // for roomMessage
        if (this.itemDetails?.isRoomMessage) {
          const messageResponse = await this.roomsMessagesService
            .create(message)
            .toPromise();

          //update message id
          message.id = messageResponse.id;
          message.dtMessage = messageResponse.dtMessage;

          this.eventQueue.dispatch(
            new AppEvent(AppEventType.SENDED_ROOM_CHAT_MESSAGE, message)
          );

          this.gatewayService.sendRoomMessageV2(messageResponse);
        } else {
          // for usermessage
          const userMessageResponse = await this.userMessageService
            .create(message)
            .toPromise();

          //update message id
          message.id = userMessageResponse.id;
          message.dtMessage = userMessageResponse.dtMessage;

          this.eventQueue.dispatch(
            new AppEvent(AppEventType.SENDED_USER_CHAT_MESSAGE, message)
          );

          this.gatewayService.sendUserMessageV2(message);
        }

        this.sortMessages(this.messages)
        message.attachment.hasError = false;
      } else {
        message.attachment.hasError = true;
      }
    } catch (error) {
      message.attachment.hasError = true;
      this.fileService.delete(fileDto.id).toPromise();
    }
  }

  private removePendingMessage(message: any) {
    const { tempId } = message;

    this.pendingRoomMessages = this.pendingRoomMessages.filter(
      (m) => m.tempId !== tempId
    );

    const msg = this.messages.find((m) => m.tempId === tempId);
    if (msg) msg.active = false;
  }

  async deleteMessage(event: boolean, message: any) {
    if (event) {
      try {
        if (message.tempId && !message.id) {
          this.removePendingMessage(message)
          return
        }
        if (this.itemDetails?.isRoomMessage) {
          await this.roomsMessagesService.delete(message.id!).toPromise();

          const confirmMessage = {
            id: message.id,
            idRoom: message.idRoom,
            idUser: this.userId,
          } as ConfirmRoomMessageRemovedDto;

          this.gatewayService.confirmRoomMessageRemoved(confirmMessage);
        } else {
          await this.userMessageService.delete(message.id!).toPromise();

          const confirmMessage = {
            id: message.id,
            idUser: this.userId,
            idDest: message.idDest,
          } as ConfirmUserMessageRemovedDto;

          this.gatewayService.confirmUserMessageRemoved(confirmMessage);
        }

        const item = this.messages.find((m) => m.id == message.id);

        if (item) {
          item.active = false;
        } else {
          throw new Error('Message not found');
        }

      } catch (error: any) {
        console.error('Error deleting message:', error);
        if (error.status == 401) {
          this.snackbarService.open(
            'Não foi possível excluir esta mensagem',
            SnackbarTypeEnum.ERROR,
            'center',
            'bottom'
          );
        }
      }
    }
  }

  async onScrollUp() {
    if (this.infiniteScrollDisabled) {
      return;
    }

    const isRoomMessage = this.itemDetails!.isRoomMessage;

    if (isRoomMessage) {
      await this.fetchRoomsMessagesWithInterval(1500);
    } else {
      await this.fetchUserMessagesWithInterval(1500);
    }
    this.scrollContainerNative.scrollTo({ top: this.scrollTopPosition });
  }

  private fetchRoomsMessagesWithInterval(interval: number): Promise<any> {
    if (
      this.totalPages &&
      this.roomMessagesParams.page &&
      this.roomMessagesParams.page < this.totalPages
    ) {
      const params: RoomMessageParamsDto = {
        page: this.roomMessagesParams.page! + 1,
        limit: this.roomMessagesParams.limit,
        idRoom: this.idRoom,
      };

      this.infiniteScrollDisabled = true;

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.getRoomsMessagesPaginated(params).then(() => {
            if (this.stopFetchData) {
              resolve((this.infiniteScrollDisabled = true));
            } else {
              resolve((this.infiniteScrollDisabled = false));
            }
          });
        }, interval);
      });
    } else {
      return Promise.resolve();
    }
  }

  private fetchUserMessagesWithInterval(interval: number): Promise<any> {
    if (
      this.totalPages &&
      this.userMessagesParams.page &&
      this.userMessagesParams.page < this.totalPages
    ) {
      const params: UserMessageParamsDto = {
        page: this.userMessagesParams.page! + 1,
        limit: this.userMessagesParams.limit,
        idAuthor: this.userId,
        idDest: this.idDestUser,
      };

      this.infiniteScrollDisabled = true;

      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.getUsersMessagesPaginated(params).then(() => {
            if (this.stopFetchData) {
              resolve((this.infiniteScrollDisabled = true));
            } else {
              resolve((this.infiniteScrollDisabled = false));
            }
          });
        }, interval);
      });
    } else {
      return Promise.resolve();
    }
  }

  onSelectForward(value: any, message: RoomMessage) {
    const existe = this.forwardList.find((item) => item.id === message.id);
    if (!existe && value) {
      this.forwardList.push(message);
    }
    if (existe && !value) {
      this.forwardList = this.forwardList.filter(
        (item) => item.id !== message.id
      );
    }
  }

  private cancelForward() {
    this.enableForward = false;
    this.forwardList = [];
  }

  onCompleteForward(value: boolean) {
    if (value) {
      this.snackbarService.open(
        'Mensagem encaminhada com sucesso',
        SnackbarTypeEnum.SUCCESS,
        'center',
        'bottom'
      );
    }
    this.cancelForward();
  }

  async onScroll() {
    const container = this.scrollContainerNative;
    const threshold = 2000;

    if (
      container.scrollHeight + container.scrollTop - container.clientHeight <
      threshold
    ) {
      //save scroll position for pagination
      this.scrollTopPosition = container.scrollTop;

      await this.onScrollUp();
    }
  }

  async requestTicketClosure() {
    const lastUpdatedDate = new Date();
    const updateTicket: UpdateTicketDto = {
      status: TicketStatus.PENDING_CLOSURE
    }
    await this.ticketService
      .update(this.ticket!.id, updateTicket)
      .toPromise()
      .then(
        (_) => {
          this.ticket!.status = TicketStatus.PENDING_CLOSURE;

          this.ticketSharedService.triggerEventFromChatDetails(this.ticket);

          const emitMessage = {
            idTicket: this.ticket!.id,
            lastUpdatedDate: lastUpdatedDate,
            idRoom: this.ticket!.idRoom,
          } as UpdateTicketEventDto

          this.ticketGatewayService.sendTicketClosureRequest(emitMessage);
        },
        (error) => {
          console.log(error);
          this.snackbarService.open(
            'Ocorreu algum erro',
            SnackbarTypeEnum.ERROR,
            'center',
            'bottom'
          );
        }
      );
  }

  defineTicketCollorButton() {
    if (!this.ticket) return 'btn-ticket-closed';

    if (this.ticket?.status === TicketStatus.ON_GOING) return 'btn-ticket-on-going'

    return 'btn-ticket-pending';
  }

  disableTicketButton() {
    if (!this.ticket || this.ticket?.status === TicketStatus.PENDING_CLOSURE) {
      return true;
    }
    return false;
  }

  hasTicketsFeatures() {
    return this.contractedFeatureUtil.hasTicketsFeature();
  }
}
